export default function FormSelect(props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <select
        style={{
          width: '620px',
          height: '50px',
          padding: '0 0 0 7px',
          margin: '10px',
          border: 'none',
          borderRadius: '6px',
          background: '#fff',
          fontWeight: '600',
          fontSize: '16px',
        }}
        value={props.hook}
        onChange={(e) => props.setHook(e.target.value)}
      >
        {props.selectOptions.map((m) => (
          <option
            key={m.value}
            value={m.value}
          >
            {m.title}
          </option>
        ))}
      </select>
    </div>
  );
}
